import {createTooltipTranslationProviderFromNamespace} from 'features/localizedTooltips/';
import {REQUIREMENTS_TRANSLATION_NAMESPACE} from './requirementsConstants';

export const RequirementsTooltipTranslationProvider =
	createTooltipTranslationProviderFromNamespace(
		REQUIREMENTS_TRANSLATION_NAMESPACE,
	);
